import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './form-container-wizard.component.scss';
var FormContainerWizard = /** @class */ (function (_super) {
    tslib_1.__extends(FormContainerWizard, _super);
    function FormContainerWizard(element) {
        return _super.call(this, element) || this;
    }
    FormContainerWizard.prototype.init = function () {
        this.wizardContainer = this.element.querySelector(".form-container-wizard__wizard");
        this.wizardStepsContainer = this.element.querySelector(".form-container-wizard__steps");
        this.bulletContainer = this.element.querySelector(".form-container-wizard__bullets-container");
        this.customHeading = this.element.querySelector(".customHeading");
        // buttons
        this.stepButtons = Array.from(this.element.querySelectorAll(".js_next-step-button"));
        this.backButton = Array.from(this.element.querySelectorAll(".js_prev-step-button"));
        this.showStep(1);
    };
    FormContainerWizard.prototype.bindEvents = function () {
        var _this = this;
        if (this.stepButtons.length) {
            this.stepButtons.map(function (item) { return item.addEventListener('click', function (event) {
                var _event = event.currentTarget;
                var _currentStep = _event.closest(".form-container-wizard__steps--step");
                if (_currentStep && (!_currentStep.classList.contains(".form-container-wizard__steps--hidden"))) {
                    var formFields = _currentStep.querySelectorAll('input, select, textarea');
                    _this.validationService.validate(formFields);
                    var valid = Array.from(_currentStep.querySelectorAll(".form__group--error"));
                    if (valid.length === 0) {
                        _this.showNextStep(event);
                    }
                }
            }); });
        }
        if (this.backButton.length) {
            this.backButton.map(function (item) { return item.addEventListener('click', function (event) {
                _this.showPreviousStep(event);
            }); });
        }
        // Reset the form
        this.wizardContainer.addEventListener('custom_wizard_reset_event', function (e) {
            _this.showStep(1);
        }, false);
    };
    FormContainerWizard.prototype.showStep = function (stepId) {
        var showStep = parseFloat(stepId);
        if (this.bulletContainer) {
            var _bullets = Array.from(this.bulletContainer.querySelectorAll(".form-container-wizard__bullets-container--bullet"));
            _bullets.map(function (pItem) {
                var displayStep = parseFloat(pItem.getAttribute("data-step"));
                if (displayStep <= showStep) {
                    pItem.classList.add("form-container-wizard__bullets-container--bullet--active");
                }
                else {
                    pItem.classList.remove("form-container-wizard__bullets-container--bullet--active");
                }
            });
        }
        var _steps = Array.from(this.wizardStepsContainer.querySelectorAll(".form-container-wizard__steps--step"));
        var _heading = '';
        _steps.map(function (pStep) {
            var _step = parseFloat(pStep.getAttribute("data-step"));
            if (_step == showStep) {
                _heading = pStep.getAttribute("data-heading");
                pStep.classList.remove("form-container-wizard__steps--hidden");
            }
            else {
                pStep.classList.add("form-container-wizard__steps--hidden");
            }
        });
        var _h3Heading = this.customHeading.querySelector("h3");
        if (_heading != '') {
            _h3Heading.innerHTML = _heading;
        }
        else {
            _h3Heading.innerHTML = '';
        }
    };
    FormContainerWizard.prototype.showNextStep = function (event) {
        var _target = event.currentTarget;
        var _currentStep = _target.closest("[data-step]");
        var _nextStep = _currentStep.getAttribute("data-step");
        this.showStep(parseFloat(_nextStep));
    };
    FormContainerWizard.prototype.showPreviousStep = function (event) {
        var _target = event.currentTarget;
        var _currentStep = _target.closest("[data-step]");
        var _nextStep = _currentStep.getAttribute("data-step");
        this.showStep(parseFloat(_nextStep));
    };
    return FormContainerWizard;
}(Base));
export { FormContainerWizard };



//////////////////
// WEBPACK FOOTER
// ./components/form-container-wizard/form-container-wizard.component.ts
// module id = 318
// module chunks = 0